import { Link, useLocation } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function NotFound() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const home = user ? "/dashboard" : "/";

  return (
    <div
      className="min-h-[80vh] flex items-center justify-center p-6"
      data-testid="not-found-page"
    >
      <div className="card-flat p-10 max-w-lg w-full text-center">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--app-accent-dark)]">
          Error 404
        </div>
        <h1 className="font-display text-5xl mt-2">
          Page not found.
        </h1>
        <p className="text-[var(--app-text-muted)] mt-3">
          The link{" "}
          <code className="px-1.5 py-0.5 bg-[var(--app-surface)] rounded text-[var(--app-text)] font-mono text-xs">
            {pathname}
          </code>{" "}
          doesn&apos;t exist on FlipPilot.
        </p>
        <div className="flex gap-2 justify-center mt-8">
          <Link
            to={home}
            className="app-btn app-btn-primary"
            data-testid="notfound-home-link"
          >
            <Home size={14} /> {user ? "Back to dashboard" : "Back to home"}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="app-btn app-btn-ghost"
            data-testid="notfound-back-button"
          >
            <ArrowLeft size={14} /> Go back
          </button>
        </div>
        <div className="text-xs text-[var(--app-text-muted)] mt-6">
          Coming from a bookmark or an email link? It may have moved. Common
          paths:{" "}
          <Link
            to={user ? "/dashboard" : "/"}
            className="text-[var(--app-accent-dark)] hover:underline"
          >
            {user ? "dashboard" : "home"}
          </Link>
          {user && (
            <>
              {" · "}
              <Link
                to="/lookup"
                className="text-[var(--app-accent-dark)] hover:underline"
              >
                property lookup
              </Link>
              {" · "}
              <Link
                to="/pipeline"
                className="text-[var(--app-accent-dark)] hover:underline"
              >
                CRM pipeline
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
